import React, { useEffect, useState } from "react";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import {
  fetchPatientMessageCountLogic,
  fetchActivePatientInDateRangeLogic,
} from "../../../store/features/patient/patientSlice";
import { useDispatch } from "react-redux";
import CardLayout from "../../common/cardLayout/CardLayout";
import { Line } from "react-chartjs-2";
import { InfoCard } from "../dashboard/DashboardHome";
import { notify } from "../../../util/helpers";

const { afterToday } = DateRangePicker;

const PatientEngagementMetrics = (props) => {
  const patientData = props.patientData;
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateRange, setDateRange] = useState([
    moment().startOf("Month").toDate(),
    moment().toDate(),
  ]);
  const [patientMessageCount, setPatientMessageCount] = useState([]);
  const [labelsData, setLabelsData] = useState([]);
  const [messageCount, setMessageCount] = useState([]);
  const [activePatientCount, setActivePatientCount] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    setStartDate(moment(dateRange[0]).format("YYYY-MM-DD"));
    setEndDate(moment(dateRange[1]).format("YYYY-MM-DD"));
  }, [dateRange]);

  useEffect(() => {
    fetchPatientMessageCountLogic({
      clinic_id: props?.user?.clinic?.id,
      start_date: startDate,
      end_date: endDate,
    })
      .then((res) => {
        setPatientMessageCount(res.data);
      })
      .catch((e) => {
        notify("Something went wrong", "error");
      });
    fetchActivePatientInDateRangeLogic({
      clinic_id: props?.user?.clinic?.id,
      start_date: startDate,
      end_date: endDate,
    })
      .then((res) => {
        setActivePatientCount(res?.data?.last_active_patients_count);
      })
      .catch((e) => {
        notify("Something went wrong", "error");
      });
  }, [startDate, endDate]);

  const handleDateRangeSelect = (dateRange) => {
    setDateRange(dateRange);
  };

  const labels = labelsData;
  useEffect(() => {
    const messageArray = {
      Sunday: 0,
      Monday: 0,
      Tuesday: 0,
      Wednesday: 0,
      Thursday: 0,
      Friday: 0,
      Saturday: 0,
    };
    for (const [key, value] of Object.entries(patientMessageCount)) {
      messageArray[moment(key).format("dddd")] += value;
    }
    setLabelsData(Object.keys(messageArray));
    setMessageCount(Object.values(messageArray));
  }, [patientMessageCount]);

  const joinedPatientsCount = () => {
    let count = 0;

    patientData.forEach((x) => {
      if (
        new Date(x.date_joined) >= new Date(startDate) &&
        new Date(x.date_joined) <= new Date(endDate)
      ) {
        count = count + 1;
      }
    });
    return count;
  };

  const data = {
    labels: labels,
    datasets: [
      {
        label: "",
        backgroundColor: "#00008B",
        borderColor: "#00008B",
        data: messageCount,
      },
    ],
  };
  const LineChart = () => {
    return (
      <Line
        data={data}
        options={{
          responsive: true,
          plugins: { legend: { display: false } },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,

              type: "linear",

              grid: {
                display: true,
              },
            },
          },
        }}
      />
    );
  };

  return (
    <div className="row container-fluid px-2 py-2">
      <div className="d-flex container-fluid w-100">
        <DateRangePicker
          placeholder="Select Date Range"
          onChange={handleDateRangeSelect}
          shouldDisableDate={afterToday()}
          value={dateRange}
        />
      </div>
      <div
        className="col-sm-12 col-md-6 col-lg-6"
        style={{
          margin: "0px",
          padding: "0px",
          border: "5px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <InfoCard
          title={"Active Patient Count"}
          stats={activePatientCount}
          information={"View all Active Patient Count"}
          show_link={false}
        />
      </div>
      <div
        className="col-sm-12 col-md-6 col-lg-6"
        style={{
          margin: "0px",
          padding: "0px",
          border: "5px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <InfoCard
          title={"New Patient Joined"}
          stats={joinedPatientsCount()}
          information={"View all New Patient Joined"}
          show_link={false}
        />
      </div>

      <CardLayout
        className="container-fluid w-100 px-1"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <LineChart />
      </CardLayout>
    </div>
  );
};

export default PatientEngagementMetrics;
